<div class="ds-rounded-icon" [ngClass]="variant + ' ' + size" [style]="'--custom-color:' + customColor">
  <app-ds-icon [name]="icon" [color]="color" [size]="iconSizeList[size]"></app-ds-icon>
</div>
